














import Vue from 'vue';
import AutoBlurTextField from '@/components/AutoBlurTextField.vue';

export default Vue.extend({
  name: 'SearchField',
  props: {
    value: String,
    autofocus: Boolean,
    loading: Boolean,
  },
  methods: {
    onInput(val: string) {
      this.$emit('input', val);
    },
  },
  components: {
    AutoBlurTextField,
  },
});
